// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"style_formLabel__3TI1n","requiredStar":"style_requiredStar__3DUsJ","requiredName":"style_requiredName__2eQS7"};